<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#zbef8bx75a)">
            <path
                d="M3.5 12c-.13 0-.26-.02-.38-.08-.37-.15-.62-.52-.62-.92V1c0-.4.24-.77.62-.92.37-.16.8-.08 1.09.21l5 5c.39.39.39 1.02 0 1.41l-5 5.01c-.19.19-.45.29-.71.29z"
            />
        </g>
        <defs>
            <clipPath id="zbef8bx75a">
                <path d="M0 0h12v12H0z" />
            </clipPath>
        </defs>
    </svg>
</template>
